// A part-timer's weekly hours are edited in hours but stored in minutes,
// like every other timesheet duration.

/** Hours typed into the form → minutes for the API; empty means "not set". */
export const weeklyHoursToMinutes = (
  hours?: number | string | null
): number | null => {
  if (hours === '' || hours === null || hours === undefined) return null;
  const value = Number(hours);
  return Number.isFinite(value) ? Math.round(value * 60) : null;
};

/** Minutes from the API → hours for the form (up to 2 decimals). */
export const weeklyMinutesToHours = (
  minutes?: number | null
): number | undefined =>
  minutes ? Math.round((minutes / 60) * 100) / 100 : undefined;
